import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import useAuthContext from 'contexts/AuthContext';
import axiosInstance from 'ns_libs/nsAxios';
import { trackDatadogRumError } from 'utils/initDatadogRum';
import { ICompany } from '../types';

const getOrganizationCompanies = async (
    orgId: string,
): Promise<ICompany[]> => {
    const response = await axiosInstance.get<ICompany[]>(
        API_ENDPOINTS.ORGANIZATION_COMPANIES(orgId),
    );
    if (!Array.isArray(response.data)) {
        trackDatadogRumError(
            new Error('[useGetOrganizationCompanies] Expected array response'),
            { receivedType: typeof response.data, receivedValue: response.data },
        );
        return [];
    }
    return response.data;
};

export const useGetOrganizationCompanies = (
    options?: Omit<UseQueryOptions<ICompany[]>, 'queryKey' | 'queryFn'>,
) => {
    const { selectedOrganizationId } = useAuthContext();
    return useQuery<ICompany[], Error>({
        queryKey: [QUERY_KEYS.ORGANIZATION.COMPANIES, selectedOrganizationId],
        queryFn: () => getOrganizationCompanies(selectedOrganizationId!),
        enabled: Boolean(selectedOrganizationId),
        ...(options ?? {}),
    });
};
